/**
 * EventView view component.
 * @module components/theme/View/EventView
 */
import moment from 'moment';
import { useSelector } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { flattenHTMLToAppURL } from '@plone/volto/helpers';
import { Grid } from 'semantic-ui-react';
import { Image } from '@plone/volto/components';
import AgendaView from 'volto-lanku/components/Views/AgendaView';

const EventTextfieldView = ({ content }) => (
  <React.Fragment>
    {content.location && (
      <div className="agenda-location-container">
        <span className="agenda-location"></span>
        <h3>{content.location}</h3>
      </div>
    )}
    {content.description && (
      <p className="documentDescription">{content.description}</p>
    )}
    {content.image && (
      <Image
        className="document-image ui right floated image"
        item={content}
        imageField="image"
      />
    )}
    {content.text && (
      <div
        dangerouslySetInnerHTML={{
          __html: flattenHTMLToAppURL(content.text.data),
        }}
      />
    )}
  </React.Fragment>
);

const EventDateView = ({ content }) => {
  const lang = useSelector((state) => state.intl.locale);
  moment.locale(lang);
  return (
    <div className="agenda-grid-element">
      <div className="agenda-date">
        <span className="month">{moment(content.start).format('MMMM')}</span>
        <span className="day">{moment(content.start).format('D')}</span>
      </div>
    </div>
  );
};

/**
 * EventView view component class.
 * @function EventView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const EventView = (props) => {
  const { content } = props;

  return content.link ? (
    <AgendaView content={content}></AgendaView>
  ) : (
    <div id="page-document" className="ui container viewwrapper event-view">
      {content.title && (
        <h1 className="documentFirstHeading">{content.title}</h1>
      )}
      <Grid>
        <Grid.Column width={3} className="mobile hidden">
          <EventDateView {...props} />
        </Grid.Column>
        <Grid.Column width={9} className="mobile hidden">
          <EventTextfieldView {...props} />
        </Grid.Column>
        <Grid.Column width={12} only="mobile">
          <EventDateView {...props} />
          <EventTextfieldView {...props} />
        </Grid.Column>
      </Grid>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
EventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
    attendees: PropTypes.arrayOf(PropTypes.string).isRequired,
    contact_email: PropTypes.string,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
    end: PropTypes.string.isRequired,
    event_url: PropTypes.string,
    location: PropTypes.string,
    open_end: PropTypes.bool,
    recurrence: PropTypes.any,
    start: PropTypes.string.isRequired,
    subjects: PropTypes.arrayOf(PropTypes.string).isRequired,
    whole_day: PropTypes.bool,
  }).isRequired,
};

export default EventView;
